import { getLang } from '@union-investment/global-resources/src/utilities/language';

export interface FetchParameters {
  apiUrl: string;
  apiKey: string;
  apiVersion: string;
  propertyId: string;
}

export interface PropertyData {
  title: string;
  latitude: string;
  longitude: string;
  adress: string;
  fond: string;
  immobilientyp: string;
  objektbeschreibung: string;
  ausstattung: string;
  baujahr: string;
  umbaujahr: string;
  erwerbsjahr: string;
  nutzfläche: string;
}

export function getUrlWithParams(apiUrl, apiVersion, propertyId) {
  const urlSearchParams = new URLSearchParams({
    action: 'getLiegenschaftsInfo',
    locale: getLang(),
    'api-version': apiVersion,
    'liegenschaft-id': propertyId,
  });

  const url = new URL(apiUrl);
  url.search = urlSearchParams.toString();

  return url.toString();
}

export function handleErrors(response) {
  if (!response.ok) {
    throw new Error(response.statusText);
  }
}

export async function fetchPropertyData({ apiUrl, apiKey, apiVersion, propertyId }: FetchParameters) {
  const url = getUrlWithParams(apiUrl, apiVersion, propertyId);
  let data;
  try {
    const response = await fetch(url, {
      headers: {
        'x-api-key': apiKey,
      },
    });
    if (!response.ok) {
      data = handleErrors(response);
    }
    data = await response.json();
  } catch (error) {
    console.log(error);
  }

  return data;
}
